export { default } from './FeaturedDestinationContainer';
